import type { ReactNode } from 'react'
import { ShieldAlert } from 'lucide-react'
import { Card, CardDescription, CardTitle } from '@/components/ui/card'

export function PageHeader({ title, actions }: { title: string; actions?: ReactNode }) {
  return (
    <header className="mb-5 flex items-center justify-between gap-4">
      <h1 className="text-xl font-bold tracking-tight">{title}</h1>
      {actions}
    </header>
  )
}

/** The yellow "Super Admin only" callout from the prototype. */
export function Notice({ children }: { children: ReactNode }) {
  return (
    <div className="mb-4 flex items-start gap-2.5 rounded-lg border border-[#f3dfa8] bg-[#fff7e6] p-3 text-[13px] leading-relaxed text-[#7a5b00]">
      <ShieldAlert className="mt-0.5 size-4 shrink-0" />
      <div>{children}</div>
    </div>
  )
}

/**
 * Honest placeholder for a screen that exists in the prototype but has no
 * backend endpoint yet. Better than a half-built screen implying it works.
 */
export function ScreenStub({ title, children }: { title: string; children: ReactNode }) {
  return (
    <Card>
      <CardTitle>{title}</CardTitle>
      <CardDescription className="mt-2">{children}</CardDescription>
    </Card>
  )
}
